<template>
    <b-container class="p-0">
        <div class="lt-choose">
            <p v-html="qdata.label2.data.value"></p>
            <div class="question-content">
                <b-row class="question-box" v-if="qdata.imageTickVertival">
                    <b-col cols="6" lg="3" md-col class="mb-4" v-for="(item, index) in qdata.imageTickVertival.data.items" :key="index">
                        <div class="question-item text-center" @click="changeValue(index)">
                            <div class="question-body mb-2">
                                <img class="mw-100" :src="imageSrc(item.image.src)" alt="">
                            </div>
                            <div class="question-footer d-flex align-items-center justify-content-center">
                                <p class="m-2 h3 ql-editor" v-html="item.label.value"></p>
                                <div class="checkbox check-true">
                                    <img class="mw-100" v-show="index === answer" :src="qdata.answer == 1 ? '' : checkDarkIcon" alt="">
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </b-container>
</template>

<script>

import {
    BRow,
    BCol,
    BContainer
} from 'bootstrap-vue'

export default {
    name: 'lt_choose',
    components: {
        BRow,
        BCol,
        BContainer
    },
    props: {
        qdata: Object
    },
    data() {
        return {
            checkDarkIcon: require('@/assets/check.png'),
            imageDefault: require('@/assets/img-default.jpg'),
            answer: null
        }
    },
    created () {
    },
    methods: {
        changeValue(value) {
            this.answer = value

            this.$emit('input', {
                answers: value,
            })
        },
        imageSrc (src) {
            if (src && src !== '') { return src }
            return this.imageDefault
        }
    },
    mounted() {
    }
}
</script>

<style scoped>
.checkbox {
    border: 2px solid;
    padding: 2px;
    margin: 10px;
    border-radius: 5px;
    cursor: pointer;
    width: 35px;
    height: 35px;
}
</style>